export const ErrorMessagesMap = new Map<string, string>();
ErrorMessagesMap.set('Sandbox Error: username reserved', 'That username is taken. Try another.');

export function getFriendlyErrorMessage(message = '') {
  if (ErrorMessagesMap.has(message)) {
    return ErrorMessagesMap.get(message);
  }
  return message;
}
